import styled from 'styled-components';

export const ButtonOptionSystemStyle = styled.button`
  width: ${({ width }) => {
    return width;
  }};
  color: ${({ theme, active, border }) => {
    if (active) {
      return theme.colors.backgroundForm;
    } else {
      return border;
    }
  }};
  background-color: ${({ theme, active, border }) => {
    if (active) {
      return border;
    } else {
      return theme.colors.backgroundForm;
    }
  }};
  font-family: inherit;
  font-size: ${({ theme }) => {
    return theme.fonts.size.superSmall;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  text-decoration: none;
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-color: ${({ border }) => {
    return border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  padding: 5px;
  margin: 0 5px 10px 0;
  cursor: pointer;
  transition: filter 200ms ease-in-out;

  &:hover {
    filter: brightness(96%);
  }
`;
